import React from "react"
import { Heading } from "frontend/components/text"
import styles from "./Layout.module.css"

const Layout = ({ children, heading, cta, renderBanner, renderFooter }) => {
  return (
    <div>
      {renderBanner()}
      <div className={styles.container}>
        <Heading size={2} className={styles.heading}>
          {heading}
        </Heading>
        <Heading size={5} className={styles.cta}>
          {cta}
        </Heading>

        {children}
      </div>
      {renderFooter()}
    </div>
  )
}

Layout.defaultProps = {
  renderBanner: () => null,
  renderFooter: () => null,
}

export default Layout
